module.exports = __webpack_public_path__ + "media/images/lp/Vector-95f85d0f6350831cf7b0896cfcc1a2e5.png";